import { useState, useContext } from "react";
import { useSelector } from 'react-redux'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { WhichWeightAPI } from 'WhichWeightAPI'
import moment from "moment";

export default function OrganizationInactiveAthletes({
    inactiveAthletes = []
}) {
    const { ShowModal } = useContext(ModalContext)

    const coachId = useSelector((state) => state.user.id)
    const organizationId = useSelector((state) => state.user.organizationId)
    const billingLocalTimestamp = useSelector((state) => state.organization.billingLocalTimestamp)

    const [expanded, setExpanded] = useState(false);

    const ShowReactivateAthleteModalWarning = (e, athlete) => {
        e.stopPropagation()

        const modalData = {
            key: ModalKey.ActionWarning,
            size: 'quarter',
            titleText: `Reactivate ${athlete.firstName} ${athlete.lastName}?`,
            bodyText: [
                'This athlete will be added back into your organization and included in your bill',
            ],
            buttonText: 'Reactivate Athlete',
            buttonAction: async () => await ReactivateAthlete(athlete)
        }

        ShowModal(modalData)
    }

    const ReactivateAthlete = async (athlete) => {
        const jsonBody = {
            userId: coachId,
            organizationId: organizationId,
            athleteId: athlete.id,
            athleteStatus: athlete.status,
            membershipAction: 'reactivate',
            localDateString: billingLocalTimestamp.format('YYYY-MM-DD'),
            utcOffsetMinutes: moment().utcOffset(), // UTC offset in minutes for timezone-aware date calculations
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('BILLING', 'POST', '/update_organization_membership', jsonBody)

        // console.log(result)

        if (result.data.status === 'failure') {
            console.error(result)
            return
        }

        window.location.reload()
    }

    // console.log(inactiveAthletes);

    if (inactiveAthletes.length === 0) return null;

    return (
        <>
            <div 
                className='p-4 flex items-center cursor-pointer'
                onClick={() => setExpanded(!expanded)}
            >
                <div className="flex-1">Inactive Athletes</div>

                <div className="pr-4 text-sm text-gray-500">
                    {inactiveAthletes.length} athlete{inactiveAthletes.length > 1 ? 's' : ''}
                </div>

                <div className="transition-transform duration-300 ease-in-out">
                    {expanded === false && <ChevronDownIcon className="h-6 w-6 text-gray-500" />}
                    {expanded === true && <ChevronUpIcon className="h-6 w-6 text-gray-500" />}
                </div>
            </div>

            <div
                className={`
                    transition-all duration-300 ease-in-out overflow-hidden divide-y divide-gray-200
                    ${expanded ? 'opacity-100' : 'max-h-0 opacity-0'}
                `}
            >
                {inactiveAthletes.map((athlete, index) => (
                    <div 
                        key={index}
                        className='p-4 flex items-center bg-gray-50'
                    >
                        <div className="text-sm pr-1">{athlete.firstName} {athlete.lastName}</div>

                        <div className="text-sm text-gray-500">
                            {athlete.email && <>({athlete.email})</>} 
                            {!athlete.email && <>(No Email)</>}
                        </div>

                        <div className="flex-1" />

                        <UserPlusIcon
                            className="h-5 w-5 mr-0.5 text-gray-400 cursor-pointer hover:text-gray-600"
                            onClick={(e) => ShowReactivateAthleteModalWarning(e, athlete)}
                        />
                    </div>
                ))}
            </div>
        </>
    )
}